import { getAIAssistantName } from 'features/user/model/selectors/userSelectors'
import { AI_BOT_USER_ID } from 'shared/constants/ai'
import { createSelector } from '@reduxjs/toolkit'
import { IMember } from '@cloudike/web_photos/dist/types/intarfaces/IMember'

import { RootState } from '../../../../shared/config/store'
import { teamMemberSelectors } from '../slice/teamSlice'
import { isAivard } from '../../../../shared/utils'

const getAvatarUrl = (member: IMember) => member && member?._links?.avatar?.href || ''

const aiBotAvatarSrc = isAivard() ? '/icons/aivard-avatar.svg' : '/icons/yagel/yagel-avatar.svg'

export const familyStateSelector = (state: RootState) => state.family

export const familySelector = (state: RootState) => state.family.familyData

export const familyMembersSelector = (state: RootState) => teamMemberSelectors.selectAll(state.family)

export const familyMembersWithAivardSelector = (state: RootState) => [
  {
    id: String(AI_BOT_USER_ID),
    name: getAIAssistantName(state),
    user_id: AI_BOT_USER_ID,
    role: 'guest',
    avatarUrl: aiBotAvatarSrc,
    _links:{
      avatar:{ href: aiBotAvatarSrc }
    }
  },
  ...teamMemberSelectors.selectAll(state.family).map((member: IMember) => ({
    ...member,
    avatarUrl: getAvatarUrl(member)
  })),
]

export const familyMembersWithAvatarsSelector = createSelector(
  familyMembersSelector,
  getAIAssistantName,
  (familyMembers, aiBotName) => {
    let allMembers = familyMembers.map((member) => ({
      ...member,
      avatarUrl: getAvatarUrl(member)
    }))
    allMembers = [...allMembers, {
      id: String(AI_BOT_USER_ID),
      name: aiBotName,
      user_id: AI_BOT_USER_ID,
      role: 'guest',
      avatarUrl: aiBotAvatarSrc,
      _links:{
        avatar:{ href: aiBotAvatarSrc }
      }
    }]
    return allMembers
  }
)

export const realFamilyMembersWithAvatarsSelector = createSelector(familyMembersWithAvatarsSelector, (familyMembers) => {
  // ai bot has id -1
  return familyMembers.filter(member => Number(member.id) > 0)
})

export const packagesSelector = (state: RootState) => state.family.packages

export const currentPackageSelector = (state: RootState) => state.family.packages.find(pkg => !!pkg.subscribed)

export const defaultPackageSelector = (state: RootState) => state.family.defaultPackage